import { urls } from "../const/urls";
import { BaseUrl, BaseUrlName } from "../types/BaseUrl";

// @ts-ignore
export const baseUrlName = (process.env.REACT_APP_ENV || "default") as BaseUrlName;
export const baseUrl: BaseUrl = urls[baseUrlName] || urls.default;
